import { useSnackbar } from "notistack";

let useSnackbarRef;
export const SnackbarUtilsConfigurator = () => {
  useSnackbarRef = useSnackbar();
  return null;
};

export default {
  successShort(msg) {
    this.toast(msg, "success", 500);
  },
  success(msg) {
    this.toast(msg, "success");
  },
  warning(msg) {
    this.toast(msg, "warning");
  },
  info(msg) {
    this.toast(msg, "info");
  },
  error(msg) {
    this.toast(msg, "error");
  },
  toast(msg, variant = "default", autoHideDuration = 3000) {
    useSnackbarRef.enqueueSnackbar(msg, { variant, autoHideDuration: autoHideDuration });
  },
};
